var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.87 263.43",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d69fa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.84,167.65c-7.8,0-14.45-1.71-20.11-5.16l-17.4,23.71c.47,.3,.94,.59,1.42,.87,10.33,6.12,22.48,9.22,36.09,9.22,11.32,0,21.82-2.36,31.23-7.02,.62-.31,1.23-.62,1.84-.95,2.89-1.55,3.69-5.34,1.75-7.98l-11-15c-1.57-2.14-4.44-2.8-6.83-1.64-5.42,2.64-11.03,3.94-16.98,3.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.14,
    cy: 139.54,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.87,69.86h-18.75c-2.11,0-4.07,1.11-5.15,2.92l-78.81,122.01-8.45-14.49c-7.56,3.41-20.64,5.04-33.79,5.75h3.33l24.41,42.47c1.07,1.86,3.05,3.01,5.2,3.01h20.27c1.15,0,2.25-.34,3.19-.93,.93-.5,1.72-1.25,2.28-2.18l62.38-94.31v122.32c0,3.31,2.69,6,6,6h17.88c3.31,0,6-2.69,6-6V75.86c0-3.31-2.69-6-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,55.98c-2.24-11.12-6.61-20.99-12.97-29.34-6.38-8.36-14.4-14.97-23.85-19.63C90.67,2.36,80.15,0,68.84,0c-13.62,0-25.76,3.1-36.09,9.22-10.38,6.14-18.54,14.87-24.26,25.94C2.86,46.08,0,58.95,0,73.43v7.76H29.88v-7.76c0-13.93,3.55-24.69,10.84-32.9,7.11-8,16.31-11.89,28.11-11.89,5.53,0,10.95,1.25,16.11,3.7,5.23,2.49,9.91,6.05,13.91,10.59,3.94,4.48,6.82,9.82,8.55,15.88,.74,2.58,3.09,4.35,5.77,4.35h17.88c1.8,0,3.5-.81,4.64-2.2,1.14-1.39,1.59-3.22,1.24-4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49,161.13c1.41,2.72,2.97,5.3,4.67,7.74h24.61v-16.89c-5.29-7.65-7.89-17.18-7.89-28.99v-13.15H0v13.15c0,14.4,2.86,27.23,8.49,38.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 81.19,
    width: 29.88,
    height: 28.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.16,168.87c4.89,7,10.97,12.81,18.17,17.33l17.4-23.71c-2.92-1.78-5.58-4.01-8-6.73-1.07-1.2-2.05-2.47-2.96-3.78v16.89H13.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,257.43c0,3.31,2.69,6,6,6h17.88c3.31,0,6-2.69,6-6v-70.38l-29.88,.45v69.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,108.79c-1.13-3.63-2.6-7.05-4.39-10.26-1.35-2.42-2.88-4.69-4.55-6.83-4.35-5.57-9.73-10.17-16.1-13.69-8.73-4.82-18.98-7.27-30.47-7.27H114.59c-3.31,0-6,2.69-6,6v110.77l29.88-.45h41.45c13.15-.72,26.22-2.34,33.79-5.75,1-.48,1.99-.99,2.96-1.52,5.97-3.32,11.07-7.6,15.28-12.75,1.98-2.42,3.78-5.01,5.36-7.82,1.28-2.28,2.39-4.67,3.33-7.15,2.66-6.98,4.01-14.74,4.01-23.17,0-7.23-.97-13.96-2.89-20.11Zm-34.42,41.76c-4.99,5.29-11.56,7.87-20.1,7.87h-48.77v-59.04h48.77c8.62,0,15.23,2.57,20.22,7.87,5.08,5.4,7.56,12.48,7.56,21.61-.07,9.2-2.58,16.29-7.68,21.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSignup);
export default __webpack_public_path__ + "static/media/logo_signup.95e7e834d857dfff8f6e150fa716ef9e.svg";
export { ForwardRef as ReactComponent };